export default "__VITE_ASSET__RwIx$Xqp__"